import { render, staticRenderFns } from "./AttestationSubmissionStatusList.vue?vue&type=template&id=7ed06c74&scoped=true"
import script from "./AttestationSubmissionStatusList.vue?vue&type=script&lang=js"
export * from "./AttestationSubmissionStatusList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed06c74",
  null
  
)

export default component.exports